import {AuthInfo} from './AuthInfo';
import {isAuthStatus} from './isAuthStatus';
import {isDefined} from '../../common/types/guards/isDefined';

export function isAuthInfo(o?: any): o is AuthInfo {
    return isDefined(o)
        && isAuthStatus(o.status);
}